import {AfterViewInit, booleanAttribute, Directive, ElementRef, Input, numberAttribute} from '@angular/core';

/**
 * Conditionally focus field after a delay
 *
 * Usage: <input nlrFocus nlrFocusDelay="number" nlrFocusIf="boolean" />
 *
 * Usage examples:
 *
 * 1. Focus field after default delay of 300ms:
 *
 *    <input nlrFocus />
 *
 * 2. Focus field after custom delay of 1000ms:
 *
 *    <input nlrFocus nlrFocusDelay="1000" />
 *
 * 3. Focus field only if nlrFocusIf expression evaluates truthy:
 *
 *    <input nlrFocus [nlrFocusIf]="someExpression" />
 */
@Directive({
    standalone: true,
    selector: '[nlrFocus]'
})
export class NlrFocusDirective implements AfterViewInit {
    @Input({transform: numberAttribute})
    nlrFocusDelay: number = 300;

    @Input({transform: booleanAttribute})
    nlrFocusIf: boolean = true;

    constructor(private elementRef: ElementRef) {}

    ngAfterViewInit(): void {
        if (this.nlrFocusIf) {
            window.setTimeout(() => {
                if (this.elementRef.nativeElement) {
                    this.elementRef.nativeElement.focus();
                }
            }, this.nlrFocusDelay);
        }
    }
}
